jQuery(document).ready(function($) {
    $(".read-more").click(function() {
        var parent = $(this).closest("div, section, article");
        var moreText = parent.find(".more-text"); 
        moreText.slideToggle(400, function() {
            if (moreText.is(":visible")) {
                parent.find(".read-more").text("Read Less-");
            } else {
                parent.find(".read-more").text("Read More+");
            }
        });
    });
});
